!(function () {
  "use strict";
  // Preserve collection sorting, searches, and variants when switching languages.
  document.querySelectorAll('.lang-switch__button').forEach(function (link) {
    var destination = new URL(link.href, location.href);
    destination.search = location.search;
    destination.hash = location.hash;
    link.href = destination.toString();
  });
  var t = window.CK || { f: {} },
    ckText = t.i18n || {},
    e = function (t, e) {
      return (e || document).querySelector(t);
    },
    o = function (t, e) {
      return Array.prototype.slice.call((e || document).querySelectorAll(t));
    },
    a =
      !window.matchMedia("(prefers-reduced-motion: reduce)").matches &&
      window.gsap &&
      window.ScrollTrigger;
  function ckTr(t, e) {
    return null != ckText[t] ? ckText[t] : e;
  }
  function ckFmt(t, e) {
    return String(t).replace(/\{\{\s*(\w+)\s*\}\}/g, function (t, o) {
      return null != e[o] ? e[o] : t;
    });
  }
  function ckType(e) {
    return (t.types && t.types[e]) || e;
  }
  function n(t) {
    return (
      "LE " +
      (t / 100).toLocaleString("en-US", { maximumFractionDigits: 2 })
    );
  }
  function r(t) {
    return String(null == t ? "" : t).replace(/[&<>"]/g, function (t) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[t];
    });
  }
  function i(t, o) {
    var a = e("#toast");
    a &&
      ((a.innerHTML = (o ? '<img src="' + o + '" alt="">' : "") + r(t)),
      a.classList.add("show"),
      clearTimeout(a._h),
      (a._h = setTimeout(function () {
        a.classList.remove("show");
      }, 2200)));
  }
  function s(t) {
    var e = t % 4;
    return 0 === t
      ? ckTr("bundleStart", "Add 4 and 2 of them are on us.")
      : 0 === e
        ? ckFmt((ckText.bundleUnlockedForms || {})[new Intl.PluralRules(window.CK.locale || 'en').select(t / 2)] || (ckText.bundleUnlockedForms || {}).other || ckTr("bundleUnlocked", "You unlocked {{ count }} free."), {
            count: t / 2,
          })
        : e < 2
          ? ckFmt(ckTr("bundleThen", "Add {{ count }} more, then the next 2 are free."), {
              count: 2 - e,
            })
          : 4 - e == 1
            ? ckTr("bundleFreeOne", "Add 1 more and it's free.")
            : ckFmt(ckTr("bundleFreeMany", "Add {{ count }} more and they're free."), {
                count: 4 - e,
              });
  }
  function c(t) {
    for (
      var e = t % 4,
        o = t > 0 && 0 === e ? 4 : e,
        a = '<div class="bars">',
        n = 0;
      n < 4;
      n++
    )
      a += '<i class="' + (n < o ? "on" : "") + '"></i>';
    return a + "</div>";
  }
  var lastCartCount = null;
  // Units that count towards "buy 2, get 2": every line except bundles
  // (bundle lines carry a hidden `_bundle` property and never qualify).
  function ckDealCount(cart) {
    return (cart.items || []).reduce(function (s, it) {
      return s + (it.properties && it.properties._bundle ? 0 : it.quantity);
    }, 0);
  }
  function restartClass(t, e, o) {
    if (!t) return;
    (clearTimeout(t._ckMotionTimer),
      t.classList.remove(e),
      void t.offsetWidth,
      t.classList.add(e),
      (t._ckMotionTimer = setTimeout(function () {
        t.classList.remove(e);
      }, o)));
  }
  function animateBagReceipt() {
    o(".bag-btn").forEach(function (t) {
      restartClass(t, "is-receiving", 720);
    });
  }
  function setCheckoutReady(t, e, a) {
    o(".checkout-action", t || document).forEach(function (t) {
      (t.classList.toggle("is-bundle-ready", e),
        a && restartClass(t, "is-celebrating", 2300));
    });
  }
  function u() {
    (document.body.classList.add("bag-open"), window.__lenis && __lenis.stop());
  }
  function l() {
    (document.body.classList.remove("bag-open", "menu-open"),
      window.__lenis && __lenis.start());
  }
  function d() {
    var route = t.routes && t.routes.cart ? t.routes.cart : "/cart";
    return fetch(route + ".js", {
      headers: { Accept: "application/json" },
    }).then(function (t) {
      if (!t.ok) throw new Error(ckTr("loadBagError", "Could not load the bag"));
      return t.json();
    });
  }
  function g(a) {
    o(".ck-count").forEach(function (t) {
      ((t.textContent = a.item_count),
        (t.style.display = a.item_count ? "grid" : "none"));
    });
    var i = ckDealCount(a),
      f = null !== lastCartCount && i > lastCartCount,
      m = i > 0 && 0 === i % 4,
      b = f && m,
      u = e("#bagProg");
    lastCartCount = i;
    u &&
      ((u.innerHTML =
        '<img src="' +
        (m ? t.f.hug : t.f.heart) +
        '" alt="" style="width:44px"><div style="flex:1">' +
        s(i) +
        c(i) +
        "</div>"),
      u.classList.toggle("is-progressing", f),
      u.classList.toggle("is-unlocked", m),
      b && restartClass(u, "is-celebrating", 1250));
    var l = e("#bagLines");
    l &&
      (a.items.length
        ? (l.innerHTML = a.items
            .map(function (t) {
              var e,
                o,
                a = t.original_line_price > t.final_line_price;
              return (
                '<div class="dl"><a class="cv" href="' +
                t.url +
                '"><img src="' +
                ((e = t.image),
                (o = 200),
                (e
                  ? e + (e.indexOf("?") > -1 ? "&" : "?") + "width=" + o
                  : "") + '" alt=""></a><div class="ln"><span class="ck-product-name" lang="en" dir="ltr">') +
                r(t.product_title.split(" - ").pop()) +
                "</span>" +
                (a ? '<span class="free-badge">' + r(ckTr("free", "free")) + "</span>" : "") +
                "<small>" +
                (t.product_type ? r(ckType(t.product_type)) + "، " : "") +
                n(t.final_price) +
                '</small></div><div class="dq"><button type="button" data-key="' +
                t.key +
                '" data-q="' +
                (t.quantity - 1) +
                '" aria-label="' + r(ckTr("removeOne", "Remove one")) + '">−</button><span>' +
                t.quantity +
                '</span><button type="button" data-key="' +
                t.key +
                '" data-q="' +
                (t.quantity + 1) +
                '" aria-label="' + r(ckTr("addOne", "Add one")) + '">+</button></div></div>'
              );
            })
            .join(""))
        : (l.innerHTML =
            '<div class="empty" style="padding:30px 0"><img src="' +
            t.f.sleep +
            '" alt="" width="170" height="170" style="width:170px"><h2 style="font-size:30px">' +
            r(ckTr("emptyBagTitle", "Your bag is napping.")) +
            '</h2><p class="sub" style="margin:8px auto 16px">' +
            r(ckTr("emptyBagCopy", "Pick a shade to wake it up.")) +
            '</p><a class="btn" href="' +
            (t.routes && t.routes.allProducts
              ? t.routes.allProducts
              : "/collections/all") +
            '">' + r(ckTr("shopNow", "Shop now")) + "</a></div>"),
      (e("#bSub").textContent = n(a.original_total_price)),
      (e("#bSave").textContent =
        (a.total_discount ? "−" : "") + n(a.total_discount)),
      (e("#bTot").textContent = n(a.total_price)),
      (e("#bagFoot").style.display = a.items.length ? "block" : "none"),
      setCheckoutReady(e("#bagFoot"), m, b));
  }
  function p(e, o) {
    return fetch(
      (t.routes && t.routes.cartAdd ? t.routes.cartAdd : "/cart/add") + ".js",
      {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ items: [{ id: Number(e), quantity: o || 1 }] }),
      },
    )
      .then(function (t) {
        return t.ok
          ? d()
          : t.json().then(function (t) {
              return (i(t.description || ckTr("addError", "Could not add to bag")), null);
            });
      })
      .then(function (e) {
        if (!e) return null;
        g(e);
        var n = ckDealCount(e),
          o = n % 4;
        (i(
          n > 0 && 0 === o
            ? ckTr("twoFreeItems", "2 free items unlocked")
            : 2 === o
              ? ckTr("addTwoFree", "Add 2 more, they're free")
              : ckTr("addedToBag", "Added to your bag"),
          n > 0 && 0 === o ? t.f.hug : t.f.heart,
        ),
          animateBagReceipt());
        return e;
      })
      .catch(function () {
        return (i(ckTr("addError", "Could not add to bag. Please try again.")), null);
      });
  }
  function setCartActionState(t, e) {
    if (!t) return;
    var o = t.querySelector(".cart-action__label"),
      a = t.getAttribute("data-default-label") || (o && o.textContent) || "Add",
      n = t.getAttribute("data-default-aria-label") || t.getAttribute("aria-label") || a;
    (t.hasAttribute("data-default-aria-label") ||
      t.setAttribute("data-default-aria-label", n),
      t.classList.remove("is-adding", "is-added", "is-add-error"));
    if ("adding" === e)
      return (
        clearTimeout(t._ckActionTimer),
        (t._ckActionWidth = t.getBoundingClientRect().width),
        (t.style.width = t._ckActionWidth + "px"),
        (t.style.minWidth = t._ckActionWidth + "px"),
        t.classList.add("is-adding"),
        (t.disabled = !0),
        t.setAttribute("aria-busy", "true"),
        t.setAttribute("aria-label", ckTr("addingToBag", "Adding to bag")),
        void (o && (o.textContent = ckTr("adding", "Adding…")))
      );
    if ("added" === e) {
      (t.classList.add("is-added"),
        (t.disabled = !0),
        t.removeAttribute("aria-busy"),
        t.setAttribute("aria-label", ckTr("addedToBag", "Added to bag")),
        o && (o.textContent = ckTr("added", "Added")));
      t._ckActionTimer = setTimeout(function () {
        setCartActionState(t, "idle");
      }, 1250);
      return;
    }
    if ("error" === e) {
      (t.classList.add("is-add-error"),
        (t.disabled = !0),
        t.removeAttribute("aria-busy"),
        t.setAttribute("aria-label", ckTr("couldNotAdd", "Could not add to bag. Try again")),
        o && (o.textContent = ckTr("tryAgain", "Try again")));
      t._ckActionTimer = setTimeout(function () {
        setCartActionState(t, "idle");
      }, 1800);
      return;
    }
    ((t.disabled = !1),
      t.removeAttribute("aria-busy"),
      t.setAttribute("aria-label", n),
      o && (o.textContent = a),
      t.style.removeProperty("width"),
      t.style.removeProperty("min-width"),
      (t._ckActionWidth = null));
  }
  ((window.ckProg = function (t) {
    return s(t) + c(t);
  }),
    document.addEventListener("keydown", function (t) {
      "Escape" === t.key && l();
    }),
    document.addEventListener("click", function (t) {
      var o = t.target.closest("[data-add]");
      o &&
        !o.disabled &&
        (t.preventDefault(),
        setCartActionState(o, "adding"),
        p(o.getAttribute("data-add"), 1).then(function (t) {
          setCartActionState(o, t ? "added" : "error");
        }));
      var a = t.target.closest("[data-key]");
      (a &&
        (t.preventDefault(),
        (function (t, e) {
          fetch(
            (t.routes && t.routes.cartChange
              ? t.routes.cartChange
              : "/cart/change") + ".js",
            {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({ id: t, quantity: Math.max(0, e) }),
            },
          )
            .then(function (t) {
              return t.json();
            })
            .then(function (t) {
              (g(t),
                document.body.classList.contains("t-cart") &&
                  location.reload());
            });
        })(a.getAttribute("data-key"), Number(a.getAttribute("data-q")))),
        t.target.closest("[data-open-bag]") && (t.preventDefault(), u()),
        t.target.closest("[data-open-menu]") &&
          (t.preventDefault(),
          document.body.classList.add("menu-open"),
          window.__lenis && __lenis.stop()),
        t.target.closest("[data-close]") && l());
      var n = t.target.closest("[data-step]");
      if (n) {
        var r = e("#qty");
        r.value = Math.max(
          1,
          Number(r.value || 1) + Number(n.getAttribute("data-step")),
        );
      }
    }),
    e("#bag") && d().then(g).catch(function () {}));
  var f = e("#pform");
  f &&
    f.addEventListener("submit", function (t) {
      if (!t.submitter || "add" === t.submitter.getAttribute("name")) {
        t.preventDefault();
        var e = new FormData(f),
          o = t.submitter || f.querySelector('[name="add"]');
        setCartActionState(o, "adding");
        p(e.get("id"), Number(e.get("quantity") || 1)).then(function (t) {
          (setCartActionState(o, t ? "added" : "error"),
            t && setTimeout(u, 700));
        });
      }
    });
  var m = o("#thumbs button");
  m.forEach(function (t) {
    t.addEventListener("click", function () {
      var o = e("#gmain");
      (m.forEach(function (t) {
        t.classList.remove("on");
      }),
        t.classList.add("on"),
        (o.innerHTML =
          '<img src="' +
          t.getAttribute("data-full") +
          '" alt="' +
          r(t.getAttribute("data-alt")) +
          '" width="' +
          r(t.getAttribute("data-width") || "1200") +
          '" height="' +
          r(t.getAttribute("data-height") || "1200") +
          '">'),
        restartClass(o, "is-media-switching", 520));
    });
  });
  o(".shades a").forEach(function (t) {
    t.addEventListener("click", function (event) {
      if (t.classList.contains("on")) return;
      t.classList.add("is-selecting");
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches)
        return;
      var o = t.getAttribute("href"),
        n = e("#gmain"),
        r = e(".pinfo h1");
      if (!o) return;
      event.preventDefault();
      n && n.classList.add("is-shade-leaving");
      r && r.classList.add("is-shade-leaving");
      try {
        sessionStorage.setItem("ck-shade-arrive", "1");
      } catch (t) {}
      setTimeout(function () {
        location.href = o;
      }, 230);
    });
  });
  try {
    if ("1" === sessionStorage.getItem("ck-shade-arrive")) {
      sessionStorage.removeItem("ck-shade-arrive");
      var w = e("#gmain"),
        S = e(".pinfo h1");
      w && restartClass(w, "is-shade-arriving", 560);
      S && restartClass(S, "is-shade-arriving", 500);
    }
  } catch (t) {}
  var b = e("#sbuy"),
    h = e("#buyRow");
  b &&
    h &&
    "IntersectionObserver" in window &&
    new IntersectionObserver(function (t) {
      b.classList.toggle(
        "show",
        !t[0].isIntersecting && t[0].boundingClientRect.top < 0,
      );
    }).observe(h);
  var y = e("#sort");
  y &&
    y.addEventListener("change", function () {
      var t = new URL(location.href);
      (t.searchParams.set("sort_by", y.value), (location.href = t.toString()));
    });
  var v = e("#gov");
  v &&
    v.addEventListener("change", function () {
      e("#ctot").textContent = n(
        Number(v.getAttribute("data-total")) + 100 * Number(v.value),
      );
    });
  var w = e("#bar");
  if (w) {
    var T = o("[data-message]", w),
      k = 0,
      I = null;
    function N() {
      ((T[k].style.cssText = "opacity:0;transform:translateY(-100%)"),
        (k = (k + 1) % T.length),
        (T[k].style.cssText = "opacity:0;transform:translateY(100%)"),
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            T[k].style.cssText = "opacity:1;transform:none";
          });
        }));
    }
    function O() {
      T.length > 1 && !I && (I = setInterval(N, 4200));
    }
    if (T.length > 1 && a) O();
  }
  var S = e("header.site");
  window.addEventListener(
    "scroll",
    function () {
      S && S.classList.toggle("small", scrollY > 40);
    },
    { passive: !0 },
  );
  var A = new Date(t.launch || "2026-09-30T18:00:00+03:00").getTime();
  function x() {
    o("[data-cd]").forEach(function (t) {
      var e;
      t.innerHTML =
        (e = A - Date.now()) <= 0
          ? '<div class="cd"><b>' + r(ckTr("live", "Live")) + '</b><span>' + r(ckTr("wereBack", "We\'re back")) + '</span></div>'
          : [
              [Math.floor(e / 864e5), ckTr("days", "days")],
              [Math.floor(e / 36e5) % 24, ckTr("hours", "hours")],
              [Math.floor(e / 6e4) % 60, ckTr("mins", "mins")],
              [Math.floor(e / 1e3) % 60, ckTr("secs", "secs")],
            ]
              .map(function (t) {
                return (
                  '<div class="cd"><b>' +
                  String(t[0]).padStart(2, "0") +
                  "</b><span>" +
                  t[1] +
                  "</span></div>"
                );
              })
              .join("");
    });
  }
  if ((x(), setInterval(x, 1e3), !a))
    return (
      o(".tube").forEach(function (t) {
        t.style.transform = "rotate(" + 9 * t.getAttribute("data-o") + "deg)";
      }),
      o(".stamp,.offer-sq").forEach(function (t) {
        t.style.transform = "none";
      }),
      void j()
    );
  if ((gsap.registerPlugin(ScrollTrigger), "undefined" != typeof Lenis)) {
    var L = new Lenis({ lerp: 0.1, smoothWheel: !0 });
    ((window.__lenis = L),
      L.on("scroll", ScrollTrigger.update),
      gsap.ticker.add(function (t) {
        L.raf(1e3 * t);
      }),
      gsap.ticker.lagSmoothing(0));
  }
  (o(".stk[data-speed]").forEach(function (t) {
    var e = Number(t.getAttribute("data-speed"));
    e &&
      gsap.to(t, {
        y: 3 * e,
        ease: "none",
        scrollTrigger: {
          trigger: t.parentElement,
          start: "top bottom",
          end: "bottom top",
          scrub: !0,
        },
      });
  }),
    gsap.set(".card,.cat", { opacity: 0 }),
    ScrollTrigger.batch(".card", {
      start: "top 94%",
      once: !0,
      onEnter: function (t) {
        gsap.fromTo(
          t,
          {
            y: 70,
            rotation: function (t) {
              return t % 2 ? 4 : -4;
            },
            opacity: 0,
          },
          {
            y: 0,
            rotation: 0,
            opacity: 1,
            duration: 0.8,
            ease: "power3.out",
            stagger: 0.07,
          },
        );
      },
    }),
    ScrollTrigger.batch(".cat", {
      start: "top 94%",
      once: !0,
      onEnter: function (t) {
        gsap.fromTo(
          t,
          { y: 60, scale: 0.9, opacity: 0 },
          {
            y: 0,
            scale: 1,
            opacity: 1,
            duration: 0.7,
            ease: "back.out(1.6)",
            stagger: 0.08,
          },
        );
      },
    }),
    o(".lk").forEach(function (t) {
      gsap.fromTo(
        t,
        { clipPath: "inset(18% 18% 18% 18% round 40px)", y: 60 },
        {
          clipPath: "inset(0% 0% 0% 0% round 28px)",
          y: 0,
          ease: "power2.out",
          scrollTrigger: {
            trigger: t,
            start: "top 95%",
            end: "top 55%",
            scrub: !0,
          },
        },
      );
      var e = t.querySelector("img");
      e &&
        gsap.fromTo(
          e,
          { scale: 1.25 },
          {
            scale: 1,
            ease: "none",
            scrollTrigger: {
              trigger: t,
              start: "top bottom",
              end: "bottom top",
              scrub: !0,
            },
          },
        );
    }),
    o(".ship b").forEach(function (t) {
      var e = t.textContent,
        o = (e.match(/\d+/g) || []).map(Number),
        a = { k: 0 };
      ScrollTrigger.create({
        trigger: t,
        start: "top 92%",
        once: !0,
        onEnter: function () {
          gsap.to(a, {
            k: 1,
            duration: 1.2,
            ease: "power2.out",
            onUpdate: function () {
              var n = 0;
              t.textContent = e.replace(/\d+/g, function () {
                return Math.round(o[n++] * a.k);
              });
            },
          });
        },
      });
    }));
  var _ = o("#fan .tube");
  _.length &&
    (gsap.set(_, { rotation: 0, y: 460, transformOrigin: "50% 100%" }),
    gsap.to(_, {
      y: 0,
      rotation: function (t, e) {
        return 9 * e.getAttribute("data-o");
      },
      duration: 1.2,
      ease: "back.out(1.4)",
      stagger: 0.08,
      delay: 0.1,
    }),
    gsap.from("#heroSq", {
      y: 200,
      rotation: -20,
      duration: 1,
      ease: "back.out(1.6)",
      delay: 0.5,
    }),
    gsap.from(".hero h1", {
      y: 50,
      opacity: 0,
      duration: 0.9,
      ease: "power3.out",
    }),
    gsap.from(".hero p,.hero .countdown,.hero .btn", {
      y: 24,
      opacity: 0,
      duration: 0.7,
      stagger: 0.08,
      delay: 0.25,
      ease: "power2.out",
    }),
    gsap
      .timeline({
        scrollTrigger: {
          trigger: ".hero",
          start: "top top",
          end: "bottom top",
          scrub: !0,
        },
      })
      .to(
        _,
        {
          rotation: function (t, e) {
            return 24 * e.getAttribute("data-o");
          },
          x: function (t, e) {
            return 38 * e.getAttribute("data-o");
          },
          y: -40,
          ease: "none",
        },
        0,
      )
      .to(".hero-copy", { y: -120, opacity: 0, ease: "none" }, 0)
      .to("#heroSq", { x: -80, rotation: -15, ease: "none" }, 0));
  j();
  var q = o("#offerSlots .drop");
  if (q.length) {
    gsap.set(q, { y: -340, rotation: -30, opacity: 0 });
    var C = gsap.timeline({
      scrollTrigger: {
        trigger: "#offer",
        start: "top top+=70",
        end: "+=120%",
        pin: !0,
        scrub: 0.6,
      },
    });
    (q.forEach(function (t, e) {
      C.to(
        t,
        { y: 0, rotation: 0, opacity: 1, duration: 1, ease: "bounce.out" },
        0.8 * e,
      );
    }),
      C.to(
        "#offerSlots .slot.free",
        { backgroundColor: "#FACCDA", duration: 0.6, stagger: 0.2 },
        "+=0.1",
      )
        .to(
          "#offerSlots .stamp",
          {
            scale: 1,
            rotation: -8,
            duration: 0.6,
            ease: "back.out(3)",
            stagger: 0.2,
          },
          "<",
        )
        .to(
          "#offerSq",
          { scale: 1, rotation: -6, duration: 0.8, ease: "back.out(2.5)" },
          "<.2",
        ));
  }
  var P = e(".band");
  function j() {
    var t = e("#storyPin");
    if (t) {
      var n = o("#shadeData > i").map(function (t) {
        return {
          n: t.getAttribute("data-name"),
          c: t.getAttribute("data-code"),
          img: t.getAttribute("data-img"),
          u: t.getAttribute("data-url"),
          d: t.getAttribute("data-desc"),
          col: t.getAttribute("data-col") || "#E56479",
          bg: t.getAttribute("data-bg"),
        };
      });
      if (n.length) {
        e("#dots").innerHTML = n
          .map(function (t, index) {
            return '<button type="button" data-shade="' + index + '" aria-controls="sName sDesc bigImg sLink" aria-pressed="false" aria-label="' + r(ckFmt(ckTr('seeNamedShade', 'See shade {{ name }}'), {name: t.n})) + '"><span style="background:' + t.col + '" aria-hidden="true"></span></button>';
          })
          .join("");
        var selectedShadeIndex = -1;
        var shadeTrigger = null;
        var shadeButtons = o('#dots button');
        function chooseShade(index) {
          if (shadeTrigger && shadeTrigger.end > shadeTrigger.start) {
            var target = shadeTrigger.start + (index + 0.5) / n.length * (shadeTrigger.end - shadeTrigger.start);
            if (window.__lenis) window.__lenis.scrollTo(target, {immediate: true});
            else window.scrollTo({top: target, behavior: 'auto'});
          }
          s(index);
        }
        shadeButtons.forEach(function (button, index) {
          button.addEventListener('click', function () { chooseShade(index); });
          button.addEventListener('keydown', function (event) {
            var next;
            var rtl = document.documentElement.dir === 'rtl';
            if (event.key === 'ArrowRight') next = (index + (rtl ? -1 : 1) + n.length) % n.length;
            if (event.key === 'ArrowLeft') next = (index + (rtl ? 1 : -1) + n.length) % n.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = n.length - 1;
            if (next == null) return;
            event.preventDefault();
            chooseShade(next);
            shadeButtons[next].focus({preventScroll: true});
          });
        });
        if ((s(0), a)) {
          var i = n.length;
          (shadeTrigger = ScrollTrigger.create({
            trigger: t,
            start: "top top",
            end: "+=" + (innerWidth < 700 ? 32 : 45) * i + "%",
            pin: !0,
            scrub: !0,
            onUpdate: function (t) {
              s(Math.min(i - 1, Math.floor(t.progress * i)));
              var e = (t.progress * i) % 1;
              (gsap.set("#bigWrap", {
                rotation: 7 * Math.sin(t.progress * Math.PI * i),
                y: -18 * Math.sin(e * Math.PI),
              }),
                gsap.set("#storySq", {
                  rotation: 6 * Math.sin(t.progress * Math.PI * i * 0.5),
                  y: 8 * Math.cos(t.progress * Math.PI * i),
                }));
            },
          }),
            gsap.from("#bigWrap", {
              scrollTrigger: {
                trigger: "#shades",
                start: "top 85%",
                end: "top top",
                scrub: !0,
              },
              y: 260,
              rotation: -25,
            }),
            gsap.from("#storySq", {
              scrollTrigger: {
                trigger: "#shades",
                start: "top 70%",
                end: "top top",
                scrub: !0,
              },
              x: 200,
              rotation: 30,
            }));
        }
      }
    }
    function s(i) {
      if (i !== selectedShadeIndex) {
        selectedShadeIndex = i;
        var s = n[i];
        ((e("#sIdx").textContent = String(i + 1).padStart(2, "0")),
          (e("#sTot").textContent = n.length),
          (e("#sName").textContent = s.n),
          (e("#sDesc").textContent = s.d),
          (e("#sLink").href = s.u),
          (e("#bigImg").src = s.img),
          (e("#bigImg").alt = s.n),
          o("#dots button").forEach(function (t, e) {
            t.classList.toggle("on", e === i);
            t.setAttribute('aria-pressed', e === i ? 'true' : 'false');
          }));
        var c =
          s.bg ||
          (function (t) {
            if ("#" !== t.charAt(0)) return "#FBE0E3";
            var e = parseInt(t.slice(1), 16);
            function o(t) {
              return Math.round(t + 0.78 * (255 - t));
            }
            return (
              "rgb(" +
              o(e >> 16) +
              "," +
              o((e >> 8) & 255) +
              "," +
              o(255 & e) +
              ")"
            );
          })(s.col);
        a
          ? (gsap.to(t, { background: c, duration: 0.5, overwrite: !0 }),
            gsap.fromTo(
              "#bigTube",
              { scale: 0.9, rotation: -6 },
              {
                scale: 1,
                rotation: 0,
                duration: 0.5,
                ease: "back.out(3)",
                transformOrigin: "50% 100%",
              },
            ),
            gsap.fromTo(
              "#sName",
              { yPercent: 40, opacity: 0 },
              { yPercent: 0, opacity: 1, duration: 0.35, ease: "power2.out" },
            ))
          : (t.style.background = c);
      }
    }
  }
  (P &&
    gsap.from(".band .bsq", {
      scrollTrigger: { trigger: P, start: "top 85%", once: !0 },
      y: 120,
      rotation: -20,
      opacity: 0,
      duration: 1,
      ease: "back.out(1.7)",
    }),
    window.addEventListener("load", function () {
      ScrollTrigger.refresh();
    }));
})();

// Refresh the homepage from Shopify's sales-ranked collection; keep server-rendered cards if unavailable.
(function () {
  var grid = document.getElementById('homeBestSellers');
  if (!grid) return;
  fetch(grid.dataset.source).then(function (response) {
    if (!response.ok) throw new Error('Best sellers unavailable');
    return response.text();
  }).then(function (html) {
    var result = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-best-sellers-results]');
    if (result && result.querySelectorAll('.card').length === 10) grid.innerHTML = result.innerHTML;
  }).catch(function () {});
})();

// Keep shade controls in the mobile copy flow so wrapped descriptions cannot overlap them.
(function () {
  var pin = document.getElementById('storyPin');
  var dots = document.getElementById('dots');
  var copy = pin && pin.querySelector('.story-in > div:first-child');
  if (!copy || !dots) return;
  var phone = window.matchMedia('(max-width: 899px)');
  function measure() {
    if (phone.matches) pin.style.setProperty('--story-details-height', copy.getBoundingClientRect().height + 'px');
  }
  function arrange() {
    (phone.matches ? copy : pin).appendChild(dots);
    measure();
  }
  arrange();
  phone.addEventListener('change', arrange);
  if (window.ResizeObserver) new ResizeObserver(measure).observe(copy);
  window.addEventListener('resize', measure);
})();
